import request from '@/api/request'

export function addBossNowUserToRegion (data) {
  return request({
    url: '/user/bossnow/region',
    method: 'post',
    data
  })
}

export function delBossNowUserToRegion (uid, id) {
  return request({
    url: '/user/bossnow/' + uid + '/region/' + id,
    method: 'delete'
  })
}
